export const checkinModalConversation = {
  guestFallback: "Gość",
  conversationLabel: "Rozmowa:",
  replyOnWhatsAppLabel: "Odpowiedz na WhatsApp:",
  replyOnWhatsAppTooltip: "Odpowiedz na WhatsApp",
};
